import React from 'react';
import PropTypes from 'prop-types';
import QuestionYesNo from './QuestionYesNo';
import QuestionSlider from './QuestionSlider';
import QuestionCertification from './QuestionCertification';

const propTypes = {
  current: PropTypes.object.isRequired,
  removalType: PropTypes.string.isRequired,
};

export const INSPECTION_BEFORE = 0;
export const INSPECTION_AFTER = 1;

export const QUESTION_TYPE_YES_NO = 0;
export const QUESTION_TYPE_SLIDER = 1;
export const QUESTION_TYPE_CERTIFICATION = 2;

export const STATUS_IN_PROGRESS = 0;
export const STATUS_COMPLETED = 1;

export const ANSWER_MOMENT_NEXT = 0;
export const ANSWER_MOMENT_STOP = 1;
export const ANSWER_MOMENT_FOLLOW_UP = 2;

export const PHOTOS_DISABLED = 0;
export const PHOTOS_REQUIRED = 1;
export const PHOTOS_OPTIONAL = 2;


export function isCertificationQuestion(question){
    return question.type == QUESTION_TYPE_CERTIFICATION;
}

export function isSliderQuestion(question){
    return question.type == QUESTION_TYPE_SLIDER;
}

export function isYesNoQuestion(question){
    return question.type == QUESTION_TYPE_YES_NO;
}

export function nextStepIsFollowup(question, value){
    return (value === '1' && question.yes_next_step === ANSWER_MOMENT_FOLLOW_UP) ||
        (value === '0' && question.no_next_step === ANSWER_MOMENT_FOLLOW_UP)
}

export function nextStepIsStop(question, value){

    if(isCertificationQuestion(question)){
        return value == '0';
    }

    return (value == '1' && question.yes_next_step == ANSWER_MOMENT_STOP) ||
        (value == '0' && question.no_next_step == ANSWER_MOMENT_STOP)
}

export function nextStepIsContinue(question, value){
    return (value === '1' && question.yes_next_step === ANSWER_MOMENT_NEXT) ||
        (value === '0' && question.no_next_step === ANSWER_MOMENT_NEXT)
}

export function photosAvailable(question){
    return photosRequired(question) || photosOptional(question);
}

export function photosRequired(question){
    return question.photos == PHOTOS_REQUIRED;
}

export function photosOptional(question){
    return question.photos == PHOTOS_OPTIONAL;
}

function Question(props) {

    let question;
    if(props.current.type == QUESTION_TYPE_YES_NO){
        question = <QuestionYesNo {... props} />;
    }

    if(props.current.type == QUESTION_TYPE_SLIDER){
        question = <QuestionSlider {... props} />;
    }

    if(props.current.type == QUESTION_TYPE_CERTIFICATION){
        question = <QuestionCertification {... props} />;
    }

    return (
        <React.Fragment>
           {question}
        </React.Fragment>
    );
  
}

Question.propTypes = propTypes;

export default Question;